/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Quick_Scan_HintInputs */

const vi_warehouse_quick_scan_hint = /** @type {(inputs: Warehouse_Quick_Scan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét mã vạch bằng máy quét hoặc camera — mỗi lần quét sẽ nhập kho ngay.`)
};

/**

* @param {Warehouse_Quick_Scan_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_quick_scan_hint = /** @type {((inputs?: Warehouse_Quick_Scan_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Quick_Scan_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_quick_scan_hint(inputs)
});